import dayjs from 'dayjs';
import * as Yup from 'yup';
import { MobileUnitAssignment, ZsdUser } from '@models';

export function useValidationSchema({
  enforceMinuteGap = true,
}: {
  enforceMinuteGap?: boolean;
} = {}) {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const validToSchema = Yup.date();

  const validToWithOrdering = enforceMinuteGap
    ? validToSchema.when('validFrom', (validFrom, schema) =>
        schema.test({
          test: (validTo: Date) =>
            dayjs(validTo).isSame(dayjs(validFrom).add(15, 'minute')) ||
            dayjs(validTo).isAfter(dayjs(validFrom).add(15, 'minute')),
          message:
            'Čas ukončenia musí byť aspoň 15 minút po začiatku platnosti',
        })
      )
    : validToSchema.when('validFrom', (validFrom, schema) =>
        schema.test({
          test: (validTo: Date) =>
            dayjs(validFrom).isSame(validTo) ||
            dayjs(validTo).isAfter(validFrom),
          message: 'Čas ukončenia nemôže byť pred začiatkom platnosti',
        })
      );

  return Yup.object<MobileUnitAssignment>().shape({
    leadTechnician: Yup.mixed<ZsdUser>(),
    technicians: Yup.mixed<ZsdUser[]>(),
    validFrom: Yup.date()
      .min(yesterday, 'Vyberte dnešný dátum alebo dátum v budúcnosti')
      .required('Povinné pole'),
    validTo: validToWithOrdering.required('Povinné pole'),
  });
}
